import ProjectsTreeCollection from './projects-collection'
import {ProjectTree} from "./@type"
import {BUS_TREE_CHANGE} from "../../gd/bus/bus-event-type"

const Debug = {
    dev: false,
    head: "ProjectsTreeCollection"
};

export default class CompaniesCollection {

    public _companies       : any

    public _projectsById    : {
        [id: ID]: ProjectTree // Number keys, string values
    } = {}

    public _companiesById   : any

    constructor(data:any) {
        this.reset(data);
    }

    reset(data:any) {
        this._companies = data ? data.slice(0) : [];

        this._projectsById  = {};
        this._companiesById = {};

        this.remap();
    }

    get singleCompany() {
        return !(this._companies && this._companies.length>1);
    }

    get companies() {
        return this._companies;
    }

    getCompany(id:ID) {
        return this._companiesById[id];
    }

    getProject(id:ID | null):ProjectTree|null {

        if (!id) return null

        return this._projectsById[id];

    }

    remap() {
        this._companies.map((el:any)=>{
            this._companiesById[el.id] = el;
        })
    }

    sortedByName() {

    }

    findProjectParents(project:ProjectTree | ID | null):ProjectTree[] {

        if (!project) return [];

        // @ts-ignore
        if (typeof project === 'string') project = this.getProject(project);

        let allParents = this._checkParentRecursively(project,[]);

        if (!allParents) allParents = [];

        return allParents.reverse();
    }

    findProjectChildren(projectId:ID, options:any = {}){
        const p = this.getProject(projectId);
        const res:any[] = [];

        const getItemsRecursive = (parent:any)=>{
            const { children } = parent;
            let items = [];
            if (children) {
                switch(options.sort){
                    case 'name':    items = children.sortedByName; break;
                    case 'func':    items = options.sortFunction(children.list()); break;
                    default:        items = children.list(); break;
                }
            }
            items.map((child:any)=>{
                res.push(child);
                getItemsRecursive(child)
            });
        };

        if (p) getItemsRecursive(p);

        return res;
    }

    findCompanyChildren(companyId?:ID, options:any = {}){
        const { sort } = options;

        const c = this.getCompany(gd.company.id)
        const res : any[]= [];

        const getItemsRecursive = (parent:any)=>{
            const { children } = parent;
            if (children) {
                let items = [];
                switch(sort){
                    case 'name':    items = children.sortedByName; break;
                    default:        items = children.list(); break;
                }
                items.map((child:any)=>{
                    res.push(child);
                    getItemsRecursive(child)
                });
            }
        };

        let projects = [];
        switch(sort){
            case 'name':    projects = c.projects!.sortedByName; break;
            default:        projects = c.projects!.list(); break;
        }

        projects.map((p:any)=>{
            res.push(p);
            getItemsRecursive(p);
        });

        return res;
    }

    _checkParentRecursively(project:any,allParents:any) {
        if (project && project.parent) {
            allParents.push(project.parent);
            this._checkParentRecursively(project.parent,allParents);
        }

        return allParents;
    }

    resetCompanyProjects(companyId:ID, options:any = {}) {
        const { silent, includeArchived, includeTemplates  } = options;

        if (Debug.dev) console.log(Debug.head,".resetCompanyProjects");

        const company = this.getCompany(companyId);
        if (!company) {
            // console.log("CompaniesCollection resetCompanyProjects: no organization found, skip", companyId);
            return;
        }

        const companyProjects = (company.projects)?company.projects.sortedByName:[];

        // remove
        if (companyProjects) {
            companyProjects.map((project:any) => {
                // remove all child projects
                this.findProjectChildren(project.id).map((p:any)=>{
                    delete this._projectsById[p.id]
                })

                delete this._projectsById[project.id]
            })
        }

        const projectsMap = {};
        const projectsTree:any[] = [];
        const projects = gd.session.projects.findCompanyProjectsForTree(companyId, {
            includeArchived: includeArchived,
            includeTemplates: includeTemplates
        });

        // console.trace('!!!resetCompanyProjects projects', companyId, projects)

        if (projects) {
            projects.map((project:any)=>{
                // @ts-ignore
                projectsMap[project.id] = project;
            });

            // REMOVE parents if no access to parent
            projects.map((project:any)=>{
                // @ts-ignore
                if (project.parentId && !projectsMap[project.parentId]) {
                    project.parentId = null;
                }
            });

            if (Debug.dev) console.log("Projects map", projectsMap);

            projects.map((project:any)=>{
                if (project.parentId) {
                    // @ts-ignore
                    const parentProject = projectsMap[project.parentId];

                    if (!parentProject) {
                        console.error("TREE ERROR, project parent not found",project);
                        project.parentId = null;
                        return;
                    }

                    // @ts-ignore
                    if (!projectsMap[parentProject.id].children) projectsMap[parentProject.id].children=[];
                    // @ts-ignore
                    projectsMap[parentProject.id].children.push(project);
                } else {
                    projectsTree.push(project);
                }
            });
        }

        company.projects = new ProjectsTreeCollection(this,projectsTree,null);

        if(!silent) gd.bus.triggerEventDebounced(BUS_TREE_CHANGE,{})
    }

    getCompanyProjectsSortMap(companyId:ID):DictionaryIdNumber {
        const sortMap : DictionaryIdNumber = {};
        const company = this.getCompany(companyId);
        let sortIndex : number = 0;

        const collectTree = (level:number, parent:any)=>{
            let items = [];

            if (parent.projects) items = parent.projects.list();
            else items = parent.children ? parent.children.list() : [];

            _.orderBy(items, project=>project.sortPosition, 'asc').map((m)=>{
                sortMap[m.id] = sortIndex++;
                collectTree(level+1, m);
            });
        };

        collectTree(0, company);

        return sortMap;
    }

}
